import { getToken } from "../../../../utils/auth";
import { dev_baseUrl } from "../../../../utils/var";

export const MarkAsRead = async (userNotificationID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {

    const queryParams = new URLSearchParams({userNotificationID}).toString();
    try {
      const response = await fetch(`${dev_baseUrl}/Notification/MarkAsRead?${queryParams}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};
